(function() { window.GUID_281e3cd0_a9af_4ef8_a5e8_d331aa504103 = { getGuid: function() { return "281e3cd0-a9af-4ef8-a5e8-d331aa504103"; } }; })();
var CS;
(function (CS) {
    let $iframe = null;
    function ShowPrintDialog(url) {
        if ($iframe != null && $iframe.length > 0) {
            let iframe = $iframe[0];
            iframe.src = url;
        }
        else {
            $iframe = $('<iframe id="AutoPrintDialogPdf" style="display:none;"></iframe>');
            let iframe = $iframe[0];
            iframe.src = url;
            iframe.onload = function () {
                setTimeout(function () {
                    iframe.focus();
                    iframe.contentWindow.print();
                }, 1);
            };
            CS.body.append($iframe);
        }
    }
    CS.ShowPrintDialog = ShowPrintDialog;
})(CS || (CS = {}));

//# sourceMappingURL=autoprintdialog.js.map
